import { render, staticRenderFns } from "./pastcompetition.vue?vue&type=template&id=b26f8100&"
import script from "./pastcompetition.vue?vue&type=script&lang=js&"
export * from "./pastcompetition.vue?vue&type=script&lang=js&"
import style0 from "./pastcompetition.vue?vue&type=style&index=0&id=b26f8100&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports